import styled from 'styled-components';

export const StyledSubheader = styled.p`
    color: black;
    font-family: Roboto Condensed, serif;
    font-weight: 300;
    font-size: 12px;
    letter-spacing: 1px;
    margin-left: 10px;
    margin-right: 10px;
`;

export const StyledSubheaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;
